export default __webpack_public_path__ + "static/media/action Pack.98ce9bec.png";